<section class="bg-white rounded-xl shadow-lg p-6 space-y-5">

  <!-- Header con indicador de filtros activos -->
  <div class="flex items-start justify-between flex-wrap gap-2">
    <div>
      <h3 class="text-lg font-semibold text-gray-900">
        <i class="fas fa-chart-line mr-2 text-blue-500"></i>
        {{ variant === 'dashboard' ? 'Vendí · Cobré · Falta cobrar' : 'Cobranza y Comisión' }}
      </h3>
      <p class="text-xs text-gray-500 mt-1">
        Las aseguradoras nos miden por <strong>cuántas emitimos</strong> y <strong>cuántas se cobraron</strong>.
        La comisión de la empresa se gana sobre las cobradas.
      </p>
    </div>
    <p class="text-xs text-gray-500 text-right">
      Período: <span class="font-medium text-gray-700">{{ periodLabel }}</span><br>
      Aseguradora: <span class="font-medium text-gray-700">{{ insurerLabel }}</span>
    </p>
  </div>

  <ng-container *ngIf="stats as g; else loadingTpl">

    <!-- Headline: % de tasa de cobranza -->
    <div class="text-center py-2 border-b border-gray-100">
      <p class="text-xs uppercase tracking-wide text-gray-500 font-medium">
        {{ labels.headlineTitle }}
      </p>
      <p class="text-5xl font-bold mt-1"
         [class.text-green-600]="!isNaNValue(g.tasaCobranza)"
         [class.text-gray-300]="isNaNValue(g.tasaCobranza)">
        <ng-container *ngIf="!isNaNValue(g.tasaCobranza); else naHeadline">
          {{ g.tasaCobranza | number:'1.0-1' }}%
        </ng-container>
        <ng-template #naHeadline>—</ng-template>
      </p>
      <p class="text-sm text-gray-500 mt-1">
        {{ labels.headlineSummary(g.pagadas, g.emitidas) }}
      </p>
    </div>

    <!-- Identidad visual: 4 cards con conectores + + = -->
    <div>
      <p class="text-xs font-medium text-gray-600 mb-3 text-center">
        {{ labels.decompositionTitle }}
      </p>
      <div class="flex flex-wrap items-stretch justify-center gap-2 md:gap-3">

        <!-- Cobré / Pagadas (verde) — clickable para drill-down -->
        <div class="flex-1 min-w-[140px]">
          <button type="button" (click)="onBucketClick('collected')"
                  class="w-full bg-green-50 rounded-lg p-3 border-l-4 border-green-500 text-left hover:bg-green-100 transition-colors cursor-pointer">
            <div class="flex items-center justify-between mb-1">
              <p class="text-xs font-semibold text-green-800">{{ labels.collected }}</p>
              <i class="fas fa-check-double text-green-500 text-sm"></i>
            </div>
            <p class="text-3xl font-bold text-green-900 leading-tight">{{ g.pagadas | number }}</p>
            <p class="text-[10px] text-green-700 mt-1">
              <ng-container *ngIf="g.emitidas > 0; else dashPct">
                {{ pct(g.pagadas, g.emitidas) | number:'1.0-1' }}% de {{ labels.sold }}
              </ng-container>
            </p>
          </button>
          <ng-container *ngIf="getBucketSplit('collected') as split">
            <button type="button" (click)="toggleBucketExpansion('collected', $event)"
                    class="mt-1 w-full text-[10px] text-green-700 hover:underline text-left px-1">
              <i class="fas mr-1" [class.fa-chevron-right]="!isBucketExpanded('collected')" [class.fa-chevron-down]="isBucketExpanded('collected')"></i>
              ver por frecuencia
            </button>
            <div *ngIf="isBucketExpanded('collected')" class="mt-1 ml-1 space-y-0.5 text-[10px] text-green-700">
              <div class="flex justify-between"><span>Anual</span><span class="font-semibold">{{ split.ANUAL | number }}</span></div>
              <div class="flex justify-between"><span>Mensual</span><span class="font-semibold">{{ split.MENSUAL | number }}</span></div>
            </div>
          </ng-container>
        </div>

        <!-- conector + -->
        <div class="flex items-center justify-center text-3xl font-bold text-gray-300 px-1 select-none">+</div>

        <!-- Cobré con error notif (ámbar) -->
        <div class="flex-1 min-w-[140px]">
          <button type="button" (click)="onBucketClick('collected_error')"
                  class="w-full bg-amber-50 rounded-lg p-3 border-l-4 border-amber-500 text-left hover:bg-amber-100 transition-colors cursor-pointer">
            <div class="flex items-center justify-between mb-1">
              <p class="text-xs font-semibold text-amber-800">{{ labels.collectedError }}</p>
              <i class="fas fa-exclamation-triangle text-amber-500 text-sm"></i>
            </div>
            <p class="text-3xl font-bold text-amber-900 leading-tight">{{ g.pagadasConError | number }}</p>
            <p class="text-[10px] text-amber-700 mt-1">
              <ng-container *ngIf="g.emitidas > 0; else dashPct">
                {{ pct(g.pagadasConError, g.emitidas) | number:'1.0-1' }}% de {{ labels.sold }}
              </ng-container>
            </p>
          </button>
          <ng-container *ngIf="getBucketSplit('collected_error') as split">
            <button type="button" (click)="toggleBucketExpansion('collected_error', $event)"
                    class="mt-1 w-full text-[10px] text-amber-700 hover:underline text-left px-1">
              <i class="fas mr-1" [class.fa-chevron-right]="!isBucketExpanded('collected_error')" [class.fa-chevron-down]="isBucketExpanded('collected_error')"></i>
              ver por frecuencia
            </button>
            <div *ngIf="isBucketExpanded('collected_error')" class="mt-1 ml-1 space-y-0.5 text-[10px] text-amber-700">
              <div class="flex justify-between"><span>Anual</span><span class="font-semibold">{{ split.ANUAL | number }}</span></div>
              <div class="flex justify-between"><span>Mensual</span><span class="font-semibold">{{ split.MENSUAL | number }}</span></div>
            </div>
          </ng-container>
        </div>

        <!-- conector + -->
        <div class="flex items-center justify-center text-3xl font-bold text-gray-300 px-1 select-none">+</div>

        <!-- Falta cobrar / Pendientes (gris) -->
        <div class="flex-1 min-w-[140px]">
          <button type="button" (click)="onBucketClick('pending')"
                  class="w-full bg-gray-50 rounded-lg p-3 border-l-4 border-gray-400 text-left hover:bg-gray-100 transition-colors cursor-pointer">
            <div class="flex items-center justify-between mb-1">
              <p class="text-xs font-semibold text-gray-700">{{ labels.pending }}</p>
              <i class="fas fa-hourglass-half text-gray-400 text-sm"></i>
            </div>
            <p class="text-3xl font-bold text-gray-800 leading-tight">{{ g.pendientes | number }}</p>
            <p class="text-[10px] text-gray-500 mt-1">
              <ng-container *ngIf="g.emitidas > 0; else dashPct">
                {{ pct(g.pendientes, g.emitidas) | number:'1.0-1' }}% de {{ labels.sold }}
              </ng-container>
            </p>
          </button>
          <ng-container *ngIf="getBucketSplit('pending') as split">
            <button type="button" (click)="toggleBucketExpansion('pending', $event)"
                    class="mt-1 w-full text-[10px] text-gray-600 hover:underline text-left px-1">
              <i class="fas mr-1" [class.fa-chevron-right]="!isBucketExpanded('pending')" [class.fa-chevron-down]="isBucketExpanded('pending')"></i>
              ver por frecuencia
            </button>
            <div *ngIf="isBucketExpanded('pending')" class="mt-1 ml-1 space-y-0.5 text-[10px] text-gray-600">
              <div class="flex justify-between"><span>Anual</span><span class="font-semibold">{{ split.ANUAL | number }}</span></div>
              <div class="flex justify-between"><span>Mensual</span><span class="font-semibold">{{ split.MENSUAL | number }}</span></div>
            </div>
          </ng-container>
        </div>

        <!-- conector = -->
        <div class="flex items-center justify-center text-3xl font-bold text-gray-300 px-1 select-none">=</div>

        <!-- Vendí / Emitidas (azul) -->
        <div class="flex-1 min-w-[140px]">
          <button type="button" (click)="onBucketClick('sold')"
                  class="w-full bg-blue-50 rounded-lg p-3 border-l-4 border-blue-500 text-left hover:bg-blue-100 transition-colors cursor-pointer">
            <div class="flex items-center justify-between mb-1">
              <p class="text-xs font-semibold text-blue-800">{{ labels.sold }}</p>
              <i class="fas fa-file-signature text-blue-500 text-sm"></i>
            </div>
            <p class="text-3xl font-bold text-blue-900 leading-tight">{{ g.emitidas | number }}</p>
            <p class="text-[10px] text-blue-700 mt-1">
              {{ labels.soldFooter }}
            </p>
          </button>
          <ng-container *ngIf="getBucketSplit('sold') as split">
            <button type="button" (click)="toggleBucketExpansion('sold', $event)"
                    class="mt-1 w-full text-[10px] text-blue-700 hover:underline text-left px-1">
              <i class="fas mr-1" [class.fa-chevron-right]="!isBucketExpanded('sold')" [class.fa-chevron-down]="isBucketExpanded('sold')"></i>
              ver por frecuencia
            </button>
            <div *ngIf="isBucketExpanded('sold')" class="mt-1 ml-1 space-y-0.5 text-[10px] text-blue-700">
              <div class="flex justify-between"><span>Anual</span><span class="font-semibold">{{ split.ANUAL | number }}</span></div>
              <div class="flex justify-between"><span>Mensual</span><span class="font-semibold">{{ split.MENSUAL | number }}</span></div>
            </div>
          </ng-container>
        </div>

        <ng-template #dashPct><span class="text-gray-400">—</span></ng-template>
      </div>
    </div>

    <!-- Stacked bar: proporción visual de la descomposición -->
    <div *ngIf="g.emitidas > 0; else noEmissionsBar" class="bg-gray-50 rounded-lg p-4">
      <div class="flex h-8 rounded-md overflow-hidden bg-gray-200">
        <div class="bg-green-500 transition-all duration-500 flex items-center justify-center text-white text-xs font-semibold overflow-hidden"
             [style.width.%]="pct(g.pagadas, g.emitidas)"
             [title]="(g.pagadas | number) + ' ' + labels.collected">
          <span *ngIf="pct(g.pagadas, g.emitidas) >= 8">{{ g.pagadas }}</span>
        </div>
        <div class="bg-amber-500 transition-all duration-500 flex items-center justify-center text-white text-xs font-semibold overflow-hidden"
             [style.width.%]="pct(g.pagadasConError, g.emitidas)"
             [title]="(g.pagadasConError | number) + ' con error de notificación'">
          <span *ngIf="pct(g.pagadasConError, g.emitidas) >= 8">{{ g.pagadasConError }}</span>
        </div>
        <div class="bg-gray-400 transition-all duration-500 flex items-center justify-center text-white text-xs font-semibold overflow-hidden"
             [style.width.%]="pct(g.pendientes, g.emitidas)"
             [title]="(g.pendientes | number) + ' ' + labels.pending">
          <span *ngIf="pct(g.pendientes, g.emitidas) >= 8">{{ g.pendientes }}</span>
        </div>
      </div>
      <div class="flex items-center justify-center gap-4 mt-3 text-[11px] text-gray-600 flex-wrap">
        <span class="flex items-center gap-1.5">
          <span class="w-3 h-3 rounded-sm bg-green-500"></span>
          {{ labels.collected }} ({{ pct(g.pagadas, g.emitidas) | number:'1.0-1' }}%)
        </span>
        <span class="flex items-center gap-1.5">
          <span class="w-3 h-3 rounded-sm bg-amber-500"></span>
          {{ labels.collectedError }} ({{ pct(g.pagadasConError, g.emitidas) | number:'1.0-1' }}%)
        </span>
        <span class="flex items-center gap-1.5">
          <span class="w-3 h-3 rounded-sm bg-gray-400"></span>
          {{ labels.pending }} ({{ pct(g.pendientes, g.emitidas) | number:'1.0-1' }}%)
        </span>
      </div>
    </div>
    <ng-template #noEmissionsBar>
      <div class="bg-gray-50 rounded-lg p-4 text-center">
        <span class="text-gray-400 text-sm">Sin emisiones en el período</span>
      </div>
    </ng-template>

    <!-- CTA compacto para los errors de notificación -->
    <div *ngIf="g.pagadasConError > 0"
         class="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start justify-between gap-3 flex-wrap">
      <div class="flex items-start gap-2 min-w-0 flex-1">
        <i class="fas fa-exclamation-triangle text-amber-600 mt-0.5 flex-shrink-0"></i>
        <p class="text-xs text-amber-800 leading-snug">
          Los <strong>{{ g.pagadasConError | number }}</strong> pagos con error de notificación
          ya cobraron en Creditotal pero la aseguradora no se enteró — requieren reintento manual.
        </p>
      </div>
      <button (click)="goToPaymentErrors.emit()" type="button"
              class="text-xs font-medium text-amber-800 hover:text-amber-900 underline decoration-amber-400 hover:decoration-amber-700 transition-colors whitespace-nowrap flex-shrink-0">
        Ver y reintentar
        <i class="fas fa-arrow-right ml-1"></i>
      </button>
    </div>

    <!-- Card slim "Errores históricos pendientes" — Solo aparece si hay
         errores activos por resolver. Suma los del período (g.pagadasConError)
         + los de períodos anteriores. Es independiente del filtro de fecha. -->
    <div *ngIf="paymentErrorsActiveTotal && paymentErrorsActiveTotal > 0"
         class="bg-orange-50 border border-orange-200 rounded-lg p-3 flex items-start justify-between gap-3 flex-wrap">
      <div class="flex items-start gap-2 min-w-0 flex-1">
        <i class="fas fa-history text-orange-600 mt-0.5 flex-shrink-0"></i>
        <p class="text-xs text-orange-800 leading-snug">
          <strong>{{ paymentErrorsActiveTotal | number }}</strong> pólizas con error de notificación
          al seguro <strong>pendientes de resolver</strong>.
          <span *ngIf="g.pagadasConError > 0">
            {{ g.pagadasConError | number }} son del período actual (arriba) y
            {{ (paymentErrorsActiveTotal - g.pagadasConError) | number }} son de períodos anteriores.
          </span>
          <span *ngIf="g.pagadasConError === 0">
            Todas son de pólizas vendidas en períodos anteriores —
            ninguna está incluida en los totales del período actual.
          </span>
        </p>
      </div>
      <button (click)="goToPaymentErrors.emit()" type="button"
              class="text-xs font-medium text-orange-800 hover:text-orange-900 underline decoration-orange-400 hover:decoration-orange-700 transition-colors whitespace-nowrap flex-shrink-0">
        Ver y reintentar
        <i class="fas fa-arrow-right ml-1"></i>
      </button>
    </div>
  </ng-container>

  <ng-template #loadingTpl>
    <div class="flex items-center justify-center py-12 text-gray-400">
      <i class="fas fa-circle-notch fa-spin mr-2"></i>
      <span class="text-sm">Cargando resumen...</span>
    </div>
  </ng-template>

</section>
